<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal
    :title="props.detailData.name + '-库位管理'"
    :width="1200"
    :open="true"
    :confirmLoading="state.loading"
    :maskClosable="false"
    @ok="onFormSubmit"
    @cancel="
      () => {
        emit('cancel')
      }
    "
    ><a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form>
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="库位编号">
                <a-input v-model:value="queryParam.code" placeholder="请输入库位编号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态" name="status">
                <a-select mode="multiple" v-model:value="queryParam.status" placeholder="请选择">
                  <a-select-option :value="1">空闲</a-select-option>
                  <a-select-option :value="2">使用中</a-select-option>
                  <a-select-option :value="3">暂停使用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="备注">
                <a-input v-model:value="queryParam.remark" placeholder="请输入"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="loadData">查询</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination" @change="onChange" rowKey="id">
        <template #bodyCell="{ column, record, index, text }">
          <template v-if="column.dataIndex == 'status'">
            <a-tag v-if="record.status == 1" color="green">空闲</a-tag>
            <a-tag v-else-if="record.status == 2" color="blue">使用中</a-tag>
            <a-tag v-else-if="record.status == 3" color="gray">暂停使用</a-tag>
            <a-tag v-else>{{ text }}</a-tag>
          </template>
          <template v-else-if="column.dataIndex === 'operate'">
            <a @click="handleRecord(record)">记录</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="`确定此库位已无执照了吗?`" v-if="record.status == 2" @confirm="handlePop(record)">
              <a>清空</a>
            </a-popconfirm>
          </template>
        </template>
      </a-table>
    </a-card>
    <!-- 格子列表 -->
    <RecordList v-if="state.detailVisible" :detailData="state.detailData" @cancel="cancel"></RecordList>
  </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
import RecordList from './RecordList.vue'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const format = 'YYYY-MM-DD HH:mm:ss'
const props = defineProps({
  detailData: {
    type: Object,
    default: () => null
  }
})
const emit = defineEmits(['cancel'])
const columns = [
  {
    title: '库位编号',
    dataIndex: 'code',
    width: 100
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 100
  },
  {
    title: '备注',
    dataIndex: 'remark',
    width: 300
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    width: 200
  },
  {
    title: '操作',
    dataIndex: 'operate',
    width: 200
  }
]
interface state {
  loading: boolean
  detailData: object
  detailVisible: boolean
}
const state = reactive<state>({
  loading: false,
  detailData: {},
  detailVisible: false
})
let queryParam = reactive<any>({
  remark: ''
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
  current: 1,
  total: undefined,
  showSizeChanger: true,
  showQuickJumper: true,
  showTotal: (total) => `总数：${total}`
})
onMounted(() => {
  loadData()
})
// 时间选择
const rangTime = computed(() => {
  let array: any = []
  if (queryParam.between_time) {
    array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
  } else {
    array = []
  }
  return array
})
// 时间选择
const rangTimeChange = (val, str) => {
  if (val) {
    queryParam.between_time = str.join(',')
  } else {
    queryParam.between_time = null
  }
}
const loadData = () => {
  state.loading = true
  // 获取到列表数据
  let requestParam = {
    url: '/admin/v1/storeCang/shelfList',
    method: 'post',
    data: Object.assign({ page: pagination.current, limit: pagination.pageSize, store_id: props.detailData.id }, queryParam)
  }
  baseService(requestParam).then((res) => {
    state.loading = false
    pagination.total = res.data.total_records
    dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
  })
}
const onChange = (val) => {
  pagination.pageSize = val.pageSize
  pagination.current = val.current
  loadData()
}
const onFormSubmit = () => {
  emit('cancel')
}
const handleRecord = (record) => {
  state.detailVisible = true
  state.detailData = { ...record }
}
const cancel = () => {
  state.detailVisible = false
}
const handlePop = (record) => {
  let requestParam = {
    url: '/admin/v1/storeCang/shelfPop',
    method: 'post',
    data: {
      id: record.id
    }
  }
  baseService(requestParam)
    .then((res: any) => {
      message.success(res.msg)
      loadData()
    })
    .catch((res) => {
      if (res.msg) {
        message.error(res.msg)
      } else {
        message.error('操作失败,请联系管理员')
      }
    })
}
</script>
<style lang="less" scoped></style>
